import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import useFileImportStore from "../stores/fileImportStore";

export default function useNavigateToImportSummary() {
  const navigate = useNavigate();
  const unparsedBoms = useFileImportStore((s) => s.unparsedBOMs);
  const successfulImports = useFileImportStore((s) => s.successfulImports);
  const currentFile = useFileImportStore((s) => s.currentFile);

  return useCallback(() => {
    navigate("/dashboard/import-bom-csv/summary/", { replace: true, state: { unparsedBoms, successfulImports, fileName: currentFile.name } });
  }, [navigate, unparsedBoms, currentFile, successfulImports]);
}
